import { FormantBaseClient } from "@formant/core/common/FormantBaseClient";
import { Uuid } from "@formant/core/model/Uuid";

interface ILatestAgentVersionResponse {
    latestAgentVersion: string | null;
}

/**
 * Hand-written rather than generated: `@formant/core` is published from another
 * repository, so its generated clients cannot pick up a new admin-api route
 * until that package is regenerated and released.
 */
export class AgentVersionClient extends FormantBaseClient {
    public async getLatestForDevice(
        token: string,
        deviceId: Uuid,
    ): Promise<string | null> {
        const response = await this.fetch<ILatestAgentVersionResponse>(
            `devices/${deviceId}/latest-agent-version`,
            { token },
        );
        return response?.latestAgentVersion ?? null;
    }
}
